<div class="file-upload-container">
  <p-fileUpload
    #fileUpload
    name="file"
    mode="basic"
    (onSelect)="onSelect($event)"
    chooseIcon="pi pi-upload"
    [chooseLabel]="label"
    [multiple]="false"
    [auto]="true"
    [disabled]="disabled"
    [accept]="
      'image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation'
    "
  ></p-fileUpload>

  <p-toast />

  <span *ngIf="filename && !disabled">
    <i class="pi pi-times" (click)="clearFile()"></i>
    <small> {{ filename }}</small>
  </span>
</div>
